export default __webpack_public_path__ + "static/media/Group684.ddc30008.svg";